import { Grid, Stack, Typography } from '@mui/material';
import useTranslation, { Translation } from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { tooltipPalette } from 'theme/tooltipPalette';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';
import { StatusLegendEntry, StatusLegendItem } from 'v2/components/StatusLegendItem/StatusLegendItem';

const getLeftLegendEntries = (translation: Translation): StatusLegendEntry[] => [
  { label: translation.active, color: tooltipPalette.success.main, filled: true },
  { label: translation.card_expired, color: tooltipPalette.error.main, filled: true },
  { label: translation.user_deleted, color: tooltipPalette.error.main, filled: true },
  { label: translation.rights_changed, color: tooltipPalette.error.main, filled: true }
];

const getRightLegendEntries = (translation: Translation): StatusLegendEntry[] => [
  { label: translation.user_expires_soon, color: tooltipPalette.warning.main, filled: true },
  { label: translation.card_expires_soon, color: tooltipPalette.warning.main, filled: true },
  { label: translation.blocked, color: tooltipPalette.text.secondary, filled: false }
];

const LegendColumn: React.FC<{ entries: StatusLegendEntry[] }> = ({ entries }) => (
  <Stack spacing={1}>
    {entries.map((entry) => (
      <StatusLegendItem key={entry.label} {...entry} />
    ))}
  </Stack>
);

export const AccessCardStatusColumnHeader: React.FC = () => {
  const { translation } = useTranslation();

  return (
    <ColumnHeaderWithTooltip
      label={translation.status}
      tooltip={
        <Stack spacing={1.5}>
          <Typography variant="caption">{translation.status_tooltip_description}</Typography>
          <Grid container spacing={1.5}>
            <Grid size={6}>
              <LegendColumn entries={getLeftLegendEntries(translation)} />
            </Grid>
            <Grid size={6}>
              <LegendColumn entries={getRightLegendEntries(translation)} />
            </Grid>
          </Grid>
        </Stack>
      }
    />
  );
};
